/* MXDVS save buttons, assets/mxdvs-save.js (06.10.2026). Loaded on every page by sections/mxdvs-wish-icon.liquid.
   Approved in the wishlist demo:
   1. Product cards (homepage, collections, search): a bookmark icon, the same as the product page, always visible,
      top right of the photo (35px tap area). Saving shows "> saved. open list", removing shows "> removed".
      A card save holds "Any size". Archived and sold out pieces can be saved too (on a sold out piece the save is
      the restock alert). The card file (snippets/mxdvs-card.liquid) stays unchanged: the button is added here.
   2. Product page: the save keeps the size that is picked (or Any). While the piece is saved, picking another size
      shows "+ also save size [size]"; "Saved sizes:" lists them, tap a size to drop it. The product page script
      (assets/mxdvs-product.js) stays unchanged: this listens to its "mx:wishlist" event.
   Everything is kept in this browser (localStorage "mxWishlist" for the pieces, "mxWishlistSizes" for the sizes).
   Once the visitor is known on the wishlist page (logged in or unlocked), saves also go to CR (admin.mxdvs.co).
   09.10.2026: "Saved sizes:" sits with the save button on desktop only: it fades in above the save button on the rail
   when a piece is saved or a size is added, dropped or picked, fades out after 2 seconds, and shows again while the
   mouse is on the save button. Phones show no "Saved sizes" (the save button has its own "Added to wishlist" text).
   09.10.2026 (later): on desktop the product page's own "Added to wishlist" / "Removed from wishlist" text and its
   hover text show at the right end of the terminal path line (~/store.mxdvs.co/collections/...), not left of the
   rail save button, where the first photo covered it. */
(function () {
  if (window.__mxSave) return;
  window.__mxSave = true;

  var LS_LIST = 'mxWishlist', LS_SIZES = 'mxWishlistSizes', LS_KNOWN = 'mxWishlistKnown';
  var CR = 'https://admin.mxdvs.co/api/wl/';
  var MARK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true" focusable="false"><path d="M6 3h12v18l-6-5-6 5z"/></svg>';
  var cfg = document.querySelector('[data-mxsave]');
  var T = {
    saved: (cfg && cfg.getAttribute('data-saved')) || '> saved. open list',
    removed: (cfg && cfg.getAttribute('data-removed')) || '> removed',
    add: (cfg && cfg.getAttribute('data-add')) || '+ also save size [size]',
    sizes: (cfg && cfg.getAttribute('data-sizes')) || 'Saved sizes:',
    url: (cfg && cfg.getAttribute('data-url')) || '/pages/wishlist'
  };

  function get(k, d) { try { var v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } }
  function put(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function list() { var l = get(LS_LIST, []); return Array.isArray(l) ? l : []; }
  function sizes() { var s = get(LS_SIZES, {}); return s && typeof s === 'object' ? s : {}; }
  function setSizes(h, v) { var s = sizes(); if (v) s[h] = v; else delete s[h]; put(LS_SIZES, s); }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function known() { return !!get(LS_KNOWN, 0); }
  function cr(path, body) {
    if (!known()) return;
    try {
      fetch(CR + path, { method: 'POST', credentials: 'include', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify(body) })
        .then(function (r) { if (r.status === 401) { try { localStorage.removeItem(LS_KNOWN); } catch (e) {} } }).catch(function () {});
    } catch (e) {}
  }
  function lightIcons(n) { document.querySelectorAll('[data-mx-wishlist-icon]').forEach(function (el) { el.classList.toggle('is-lit', n > 0); }); }

  /* saves a piece the same way as the product page (newest first, 50 at most) and tells the page */
  function save(h, on, sz) {
    var l = list().filter(function (x) { return x !== h; });
    if (on) l.unshift(h);
    l = l.slice(0, 50);
    put(LS_LIST, l);
    setSizes(h, on ? (sz || ['Any']) : null);
    document.dispatchEvent(new CustomEvent('mx:wishlist', { detail: { handle: h, saved: on, count: l.length, source: 'mxdvs-save' } }));
    lightIcons(l.length);
    if (on) cr('save', { handle: h, sizes: sz || ['Any'] }); else cr('remove', { handle: h });
  }

  /* ================= 1. product cards ================= */
  function handleOf(a) { var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9][a-z0-9-]*)/); return m ? m[1] : ''; }
  function addButtons(rootEl) {
    var cards = (rootEl || document).querySelectorAll ? (rootEl || document).querySelectorAll('a.mx-card') : [];
    var saved = list();
    Array.prototype.forEach.call(cards, function (a) {
      var media = a.querySelector('.mx-card__media'), h = handleOf(a);
      if (!media || !h || media.querySelector('.mx-csave')) return;
      var on = saved.indexOf(h) > -1;
      var b = document.createElement('span');
      b.className = 'mx-csave' + (on ? ' is-on' : '');
      b.setAttribute('role', 'button'); b.setAttribute('tabindex', '0');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      b.setAttribute('data-h', h);
      b.innerHTML = MARK;
      media.appendChild(b);
    });
  }
  function syncButtons() {
    var saved = list();
    document.querySelectorAll('.mx-csave').forEach(function (b) {
      var on = saved.indexOf(b.getAttribute('data-h')) > -1;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  function flash(b, on) {
    var media = b.parentNode, old = media.querySelector('.mx-csave__line');
    if (old) old.remove();
    var line = document.createElement('span');
    line.className = 'mx-csave__line';
    line.setAttribute('role', 'status');
    if (on) {
      var parts = T.saved.split(/(open list)/i);
      line.innerHTML = parts.map(function (p) { return /^open list$/i.test(p) ? '<span class="mx-csave__open" role="link" tabindex="0" data-open>' + esc(p) + '</span>' : esc(p); }).join('');
    } else line.textContent = T.removed;
    media.appendChild(line);
    requestAnimationFrame(function () { line.classList.add('is-in'); });
    clearTimeout(b._t);
    b._t = setTimeout(function () { line.classList.remove('is-in'); setTimeout(function () { line.remove(); }, 300); }, on ? 2600 : 1400);
  }
  function toggleCard(b) {
    var h = b.getAttribute('data-h'), on = list().indexOf(h) < 0;
    save(h, on, ['Any']);
    syncButtons();
    flash(b, on);
  }
  /* capture: the card is a link, so the button and the "open list" line must stop it from opening the product */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null; if (!t) return;
    var open = t.closest('.mx-csave__open');
    if (open) { e.preventDefault(); e.stopPropagation(); location.href = T.url; return; }
    if (t.closest('.mx-csave__line')) { e.preventDefault(); e.stopPropagation(); return; }
    var b = t.closest('.mx-csave');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    toggleCard(b);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('.mx-csave__open')) { e.preventDefault(); e.stopPropagation(); location.href = T.url; return; }
    var b = t.closest('.mx-csave'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); toggleCard(b);
  }, true);

  /* ================= 2. product page: more than one size ================= */
  var pp = null; // { root, view, D, sizeIdx }
  function ppInit() {
    var root = document.querySelector('[data-mxp-json]');
    if (!root) return;
    var D; try { D = JSON.parse(root.textContent); } catch (e) { return; }
    var view = document.querySelector('[data-mxp-view]');
    if (!D || !D.handle || !view || !Array.isArray(D.options)) return;
    var si = -1;
    D.options.forEach(function (o, i) { if (si < 0 && o && (o.size || /size|maat|taille/i.test(o.name || ''))) si = i; });
    if (si < 0 || (D.options[si].values || []).length < 2) return;
    pp = { view: view, D: D, si: si };
    var t;
    new MutationObserver(function (ms) { if (ms.every(function (m) { return m.target.closest && m.target.closest('.mx-psz'); })) return; clearTimeout(t); t = setTimeout(function () { ppLine(); }, 30); }).observe(view, { childList: true, subtree: true });
    ppLine();
  }
  function picked() {
    var b = pp.view.querySelector('.pp-opt .pp-size.is-selected[data-opt="' + pp.si + '"]');
    return b ? b.getAttribute('data-val') : '';
  }
  var HOLD = 2000, tipT = 0, lastPick = '';
  function ppLine(flash) {
    if (!pp) return;
    var h = pp.D.handle, on = list().indexOf(h) > -1, cur = sizes()[h] || ['Any'], sel = picked();
    var desk = window.innerWidth >= 990;
    var btn = desk ? pp.view.querySelector('.pp-rail .pp-wish') : null;
    var old = pp.view.querySelector('.mx-psz');
    if (!on || !btn) { if (old) old.remove(); return; }
    if (sel !== lastPick) { if (lastPick || sel) flash = true; lastPick = sel; }
    var html = '<span class="mx-psz__k">' + esc(T.sizes) + '</span>';
    if (cur.indexOf('Any') < 0) html += cur.map(function (s) { return '<button type="button" class="mx-psz__s" data-drop="' + esc(s) + '" aria-label="Stop saving size ' + esc(s) + '">' + esc(s) + '</button>'; }).join('');
    else html += '<span class="mx-psz__any">Any</span>';
    if (sel && cur.indexOf(sel) < 0 && cur.indexOf('Any') < 0) html += '<button type="button" class="mx-psz__add" data-add="' + esc(sel) + '">' + esc(desk ? T.add.replace('[size]', sel) : '+ ' + sel) + '</button>';
    var where = desk ? 'd' : 'm', box = old, host = btn.parentNode;
    if (!box || box.getAttribute('data-where') !== where || box.parentNode !== host || box.nextElementSibling !== btn) {
      if (old) old.remove();
      box = document.createElement('div'); box.setAttribute('role', 'status');
      if (window.getComputedStyle(host).position === 'static') host.classList.add('mx-psz-host');
      host.insertBefore(box, btn);
      box.className = 'mx-psz mx-psz--' + where + (desk && tipT ? ' is-on' : '');
    }
    box.setAttribute('data-where', where);
    if (box.getAttribute('data-html') !== html) { box.setAttribute('data-html', html); box.innerHTML = html; }
    if (desk && flash) {
      clearTimeout(tipT); box.classList.add('is-on');
      tipT = setTimeout(function () { tipT = 0; var b = pp.view.querySelector('.mx-psz--d'); if (b) b.classList.remove('is-on'); }, HOLD);
    }
  }
  /* desktop: the save button's own text ("Added to wishlist", hover "Add to wishlist") at the end of the path line */
  var tagT = 0, tagHover = false;
  function wishText() { var l = document.querySelector('.pp-rail .pp-wish .pp-wish__label'); return l ? (l.getAttribute('data-label') || l.textContent || '') : ''; }
  function pathTag(txt, hold) {
    if (window.innerWidth < 990) return;
    var path = document.querySelector('[data-mxp-view] .pp-info > .pp-path');
    if (!path) return;
    var tag = path.querySelector('.mx-wishtag');
    if (!tag) { tag = document.createElement('span'); tag.className = 'mx-wishtag'; tag.setAttribute('role', 'status'); path.appendChild(tag); }
    if (txt) { tag.textContent = txt; tag.classList.add('is-on'); }
    if (hold) { clearTimeout(tagT); tagT = setTimeout(function () { tagT = 0; if (!tagHover) tag.classList.remove('is-on'); }, hold); }
    if (!txt && !tagT) tag.classList.remove('is-on');
  }
  /* desktop: pointing at the save button shows the saved sizes and the save text again */
  document.addEventListener('mouseover', function (e) {
    if (window.innerWidth < 990) return;
    var w = e.target.closest && e.target.closest('.pp-rail .pp-wish, .pp-rail .mx-psz');
    if (!w || (e.relatedTarget && w.contains(e.relatedTarget))) return;
    if (pp) ppLine(true);
    if (w.classList.contains('pp-wish')) { tagHover = true; pathTag(wishText()); }
  });
  document.addEventListener('mouseout', function (e) {
    var w = e.target.closest && e.target.closest('.pp-rail .pp-wish');
    if (!w || (e.relatedTarget && w.contains(e.relatedTarget))) return;
    tagHover = false; pathTag('');
  });
  window.addEventListener('resize', function () { clearTimeout(ppLine._t); ppLine._t = setTimeout(function () { ppLine(); }, 120); });
  document.addEventListener('click', function (e) {
    if (!pp) return;
    var add = e.target.closest && e.target.closest('.mx-psz__add'), drop = e.target.closest && e.target.closest('.mx-psz__s');
    if (!add && !drop) return;
    e.preventDefault();
    var h = pp.D.handle, cur = (sizes()[h] || ['Any']).filter(function (s) { return s !== 'Any'; });
    if (add) { var v = add.getAttribute('data-add'); if (cur.indexOf(v) < 0) cur.push(v); }
    if (drop) { var d = drop.getAttribute('data-drop'); cur = cur.filter(function (s) { return s !== d; }); }
    if (!cur.length) cur = ['Any'];
    setSizes(h, cur); cr('sizes', { handle: h, sizes: cur });
    ppLine(true);
  });
  /* the product page's own save button: keep the size that was picked (or Any) */
  document.addEventListener('mx:wishlist', function (e) {
    var d = e.detail || {};
    if (d.source || !d.handle) { syncButtons(); return; }
    setTimeout(function () { var t = wishText(); if (t) pathTag(t, 1800); }, 60);
    if (pp && d.handle === pp.D.handle) {
      if (d.saved) { var s = picked(); setSizes(d.handle, [s || 'Any']); cr('save', { handle: d.handle, sizes: [s || 'Any'] }); }
      else { setSizes(d.handle, null); cr('remove', { handle: d.handle }); }
      setTimeout(function () { ppLine(!!d.saved); }, 30);
    } else if (d.saved != null) {
      if (d.saved) cr('save', { handle: d.handle, sizes: sizes()[d.handle] || ['Any'] }); else cr('remove', { handle: d.handle });
    }
    syncButtons();
  });
  window.addEventListener('storage', function (e) { if (e.key === LS_LIST) { syncButtons(); lightIcons(list().length); } if (e.key === LS_SIZES) ppLine(); });
  window.addEventListener('pageshow', syncButtons);

  function init() {
    addButtons(document);
    ppInit();
    /* cards added later (load more, filters, search results) */
    var t;
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { clearTimeout(t); t = setTimeout(function () { addButtons(document); }, 60); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { addButtons(document); });
})();
